"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eComSFSMCommon = void 0;
var angular = require("angular");
require("../externals");
var TransactionedAction_1 = require("./directives/TransactionedAction");
var userFreeText_1 = require("./components/userFreeText");
var eComAppConfig_1 = require("./eComAppConfig");
var writeExperimentsAsAttributes_1 = require("./directives/writeExperimentsAsAttributes/writeExperimentsAsAttributes");
var utils_1 = require("./services/utils");
var SocialShareService_1 = require("./services/SocialShareService");
var ApiUrlParser_1 = require("./services/ApiUrlParser");
var HostingService_1 = require("./services/HostingService");
var sdkAdapter_1 = require("./services/sdkAdapter");
require("./eComAppConfig");
require("./services/TranslateEscapedInterpolationFactory");
var BulkCommandsExecutorService_1 = require("./services/BulkCommandsExecutorService");
var CommandsExecutorFactory_1 = require("./services/CommandsExecutorFactory");
var GUIDGeneratorService_1 = require("./services/GUIDGeneratorService");
var LocalStorageService_1 = require("./services/LocalStorageService");
var HttpFacade_1 = require("./services/HttpFacade");
var HostingService_2 = require("./services/HostingService");
var isWebpSupported;
try {
    isWebpSupported = require('supports-webp');
}
catch (_a) {
    isWebpSupported = false;
}
/* @ngInject */
exports.eComSFSMCommon = angular
    .module('eComSFSMCommon', ['wixAngular', 'WixBI', 'pascalprecht.translate'])
    .config(eComAppConfig_1.eComSFSMCommonConfig)
    .constant('appDefId', '1380b703-ce81-ff05-f115-39571d94dfcd')
    .service('utils', utils_1.Utils)
    .directive('writeExperimentsAsAttributes', writeExperimentsAsAttributes_1.writeExperimentsAsAttributes)
    .directive('transactionedAction', TransactionedAction_1.transactionedAction)
    .service('socialShareService', SocialShareService_1.SocialShareService)
    .service('ApiUrlParser', ApiUrlParser_1.ApiUrlParser)
    .service('hostingService', HostingService_1.HostingService)
    .component('userFreeText', userFreeText_1.userFreeText)
    .factory('GraphQlEnumValue', function () { return gql.EnumValue; })
    .factory('GraphQlQueryBuilder', function () { return gql.GraphQlQuery; })
    .provider('Wix', sdkAdapter_1.WixProvider)
    .provider('sdkAdapter', sdkAdapter_1.SdkAdapterProvider)
    .service('BulkCommandsExecutorService', BulkCommandsExecutorService_1.BulkCommandsExecutorService)
    .provider('CommandsExecutorFactory', CommandsExecutorFactory_1.CommandsExecutorFactoryProvider)
    .service('GUIDGeneratorService', GUIDGeneratorService_1.GUIDGeneratorService)
    .service('LocalStorageService', LocalStorageService_1.LocalStorageService)
    .provider('HttpFacade', HttpFacade_1.HttpFacadeProvider)
    .provider('HostingService', HostingService_2.HostingServiceProvider)
    .constant('browserFeatures', {
    isWebpSupported: isWebpSupported,
})
    .run(function ($translate, experimentManager) {
    if (experimentManager.isExperimentEnabled('specs.RemoveTranslationsValues')) {
        $translate.uses('noValue');
    }
}).name;
